import apiClient from './client.js';
const base = (wsId) => `/workspaces/${wsId}/webhooks`;
export const list = (wsId) => apiClient.get(base(wsId)).then(r => r.data);
export const create = (wsId, dto) => apiClient.post(base(wsId), dto).then(r => r.data);
export const update = (wsId, id, dto) => apiClient.patch(`${base(wsId)}/${id}`, dto).then(r => r.data);
export const remove = (wsId, id) => apiClient.delete(`${base(wsId)}/${id}`).then(r => r.data);
export const listDeliveries = (wsId, id) => apiClient.get(`${base(wsId)}/${id}/deliveries`).then(r => r.data);
export const getEventTypes = (wsId) => apiClient.get(`${base(wsId)}/event-types`).then(r => r.data);
